<nav class="u-m-b-16">
    <ul class="breadcrumbs">
        <li>Distribution</li>
    </ul>
</nav>
<header class="u-m-b-40">
    <div class="row">
        <div class="columns">
            <h1 class="typography--display1">Distribution</h1>
        </div>
    </div>
</header>
<main role="main">
    <div class="row">
        <div class="columns">
            <div class="card spinner-section" [class.spinner-section--is-active]="vm.loadingCharges">
                <div class="spinner-section__icon"></div>
                <opus-shipping-charges-header [shippingCharges$]="shippingCharges$"
                                              (criteriaChangeEvent)="onCriteriaChange($event)"></opus-shipping-charges-header>
                <div class="columns">
                    <span></span>
                </div>
                <div class="row">
                    <div class="columns">
                        <span></span>
                    </div>
                    <div class="columns shrink">
                        <div class="columns" *ngIf="(shippingCharges$ | async)?.length > 0 && (criteria?.rentalCategoryCode || criteria?.state)">
                            <div class="btn-group">
                                <div *ngIf="!isEditing">
                                    <button class="btn btn--hollow btn--tiny btn--edit btn-group__btn"
                                            (click)="onToggleEdit()" opusAuthorize="Distribution.ViewShippingCharges" [opusRelationshipManagerRoles]="['aa_OPUS-MAA_EntityAdmin']" [opusRelationshipManagerEmail]="relationshipManagerEmail">
                                        Edit
                                    </button>
                                </div>
                                <div *ngIf="isEditing">
                                    <button class="btn btn--tiny btn--edit btn-group__btn"
                                            (click)="onSaveChanges()">
                                        Save Changes
                                    </button>
                                    <button class="btn btn--hollow btn--tiny btn-group__btn"
                                            (click)="onToggleEdit()">
                                        Cancel Edit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>
                <opus-shipping-charges-table #editor
                                             [criteria]="criteria"
                                             [shippingCharges$]="shippingCharges$"
                                             [isEditing]="isEditing"></opus-shipping-charges-table>
            </div>
        </div>
    </div>
</main>
